import PowerPreparedness from 'elem/compPage/PowerPreparedness';
import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useGlobal } from '@/utils/useGlobal';
import PageLayout from '@/components/PageLayout';
import seoconfig from '@/seoconfig/power-preparedness';
import SEOlinksA from '@/components/SEOlinksA';
import { redirectTo404 } from '@/utils';
import { appendScriptContentToHead } from '@/utils/singUtil/appendScriptToHead';

export default function PowerPreparednessPage({ SEO }: any) {
    const { useRouter, useLang } = useGlobal();
    const { t } = useLang('powerpreparedness');
    const { locale } = useRouter();
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    useEffect(() => {
        setTimeout(() => {
            appendScriptContentToHead(`
                setTimeout(function () {
                    trackPageView();
                }, 40000);
                
                function trackPageView() {
                    const timeOnPage = Math.floor(performance.now() / 1000); // Calculate time on page in seconds
                    if (timeOnPage > 40 && typeof fbq === 'function') {
                        fbq('track', 'PageView40s');
                    }
                }
            `);
        }, 3000);
    }, []);

    return (
        <PageLayout isNoFixed hideToTop theme="white">
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={String(locale)} list={seoconfig.include} pathname={seoconfig.url} />
            <GtmPageLoad />
            <PowerPreparedness />
        </PageLayout>
    );
}

export async function getServerSideProps({ locale }: { locale: string }) {
    if (!['us', 'ca'].includes(locale)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
